import Amplify, { Auth } from 'aws-amplify';

import { COGNITO } from './cognito-intranet';

Amplify.configure({
  aws_cognito_region: COGNITO.REGION,
  aws_user_pools_id: COGNITO.USER_POOL_ID,
  aws_user_pools_web_client_id: COGNITO.APP_CLIENT_ID,
});

export const getTokenIntranet = {
  query: ({ password, username }) => Auth.signIn({ username, password }),
  format: (data) => data,
};

export const signOutIntranet = async () => {
  await Auth.signOut();
};
